import axios, { AxiosPromise, CancelTokenSource } from 'axios';
import { getSnakeNewWatcherQueryParams } from '../components/search-watcher/searchWatcherUtils';
import {
  SearchParams,
  SearchAPICount,
  SearchAPIResponse,
  ReportSearchParams,
} from '../search.types';
import {
  WatcherQueryParamsEnum,
  WatcherSearchQueryEnum,
  WatcherWithoutDocuments,
} from '../../watchers/watchers.types';

export type ErrorType = { errorMessage?: string; error?: string };

export function ajaxSearch(
  params: SearchParams,
): [AxiosPromise<SearchAPIResponse & ErrorType>, CancelTokenSource] {
  const source = axios.CancelToken.source();

  const promise = axios.get('/api/search', {
    params,
    cancelToken: source.token,
  });
  return [promise, source];
}

export function ajaxSearchCount(
  params: SearchParams,
): [
  AxiosPromise<
    SearchAPICount & {
      error: string;
    }
  >,
  CancelTokenSource,
] {
  const source = axios.CancelToken.source();

  const promise = axios.get('/api/search/count', {
    params,
    cancelToken: source.token,
  });
  return [promise, source];
}

export function checkIfWatcherAlreadyExists(
  params: SearchParams,
): [
  AxiosPromise<
    WatcherWithoutDocuments & {
      error: string;
    }
  >,
  CancelTokenSource,
] {
  const source = axios.CancelToken.source();
  const type =
    params.type === WatcherQueryParamsEnum.DECISION
      ? WatcherSearchQueryEnum.DECISION
      : WatcherSearchQueryEnum.COMMENTARY;

  const promise = axios.get(`/watchers/queries/${type}`, {
    params: getSnakeNewWatcherQueryParams(params),
    cancelToken: source.token,
  });
  return [promise, source];
}

export const reportSearchEndPoint = (reportData: ReportSearchParams) =>
  axios({
    method: 'POST',
    url: '/api/search/report',
    data: reportData,
  });

export const getAggregations = (params: SearchParams) =>
  axios.get<SearchAPIResponse['aggregations']>('/api/search/aggregations', {
    params,
  });
